import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})
export class CompanyProfileComponent implements OnInit{

  videoUrl!: SafeResourceUrl;
  @Input() data : any;
  turstedDescriptionHTML!: SafeHtml;   

  constructor(
    private sanitizer: DomSanitizer, 
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/Rd4wMe9ucvk?si=BRVloh61xU8_er5W');
    const descriptionHTML = this.sanitizer.bypassSecurityTrustHtml(this.data?.description);
    this.turstedDescriptionHTML = descriptionHTML;
  }

  images: string[] = [
    "../../../assets/images/icons/image 63.svg", 
    "../../../assets/images/icons/image 57.svg",
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg" ,
    "../../../assets/images/icons/image 60.svg",
  "../../../assets/images/icons/image 57.svg",
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg" ,
    "../../../assets/images/icons/image 60.svg",
    "../../../assets/images/icons/image 63.svg", 
    "../../../assets/images/icons/image 57.svg",
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg" ,
    "../../../assets/images/icons/image 60.svg",
    "../../../assets/images/icons/image 57.svg",
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg", 
    "../../../assets/images/icons/image 60.svg" ,
    "../../../assets/images/icons/image 60.svg",
    "../../../assets/images/icons/image 60.svg",
  ];
 
  showMore = false;

  get visibleImages() {
    return this.showMore ? this.images.slice(0, 6) : this.images.slice(0, 5);
  }

  get hiddenImagesCount() {
    return this.images.length - 6;
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }
  getEmbedUrl(videoUrl: string): string {
   
    if (videoUrl.includes('embed')) {
      return videoUrl;
    }
    
    const videoId = this.extractVideoId(videoUrl);
   
    
    return `https://www.youtube.com/embed/${videoId}`;
  }

  private extractVideoId(url: string): string {
    const videoIdMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/
    );
    return videoIdMatch ? videoIdMatch[1] : '';
  }
  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  
  
}
